import angular from "angular";

import SearchStringTokenizerModule from "./SearchStringTokenizerService";
import SearchRequestSyntaxParserModule from "./SearchRequestSyntaxParserService";

import SearchRequestParserService from "./SearchRequestParserService";

export default angular
    .module("trackerbase-app.services.search-request-parser.search-request-parser-service", [
        SearchStringTokenizerModule,
        SearchRequestSyntaxParserModule
    ])
    .service("SearchRequestParserService", SearchRequestParserService) // injector info in $inject
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/services/search-request-parser/index.js
// module id = N4mu
// module chunks = 1